@if (showShippingInfo) {
<hr>
<div>
    <label class="header-label">Shipping info:</label>
    @if (fintechService.editMode!="none" && fintechService.editMode!="shipping") {
    <table>
        <tr>
            <td>Company:</td>
            <td>{{this.shippingInfo?.company}}</td>
            <td>FirstName:</td>
            <td>{{this.shippingInfo?.firstName}}</td>
            <td>LastName:</td>
            <td>{{this.shippingInfo?.lastName}}</td>
        </tr>
        <tr>
            <td>Address:</td>
            <td>{{this.shippingInfo?.address1}}</td>
            <td>{{this.shippingInfo?.address2}}</td>
            <td>City:</td>
            <td>{{this.shippingInfo?.city}}</td>
        </tr>
        <tr>
            <td>State:</td>
            <td>{{this.shippingInfo?.state}}</td>
            <td>PostalCode</td>
            <td>{{this.shippingInfo?.zipCode}}</td>
            <td>Country:</td>
            <td>{{this.shippingInfo?.country}}</td>
        </tr>
        <tr>
            <td>Phone1:</td>
            <td>{{this.shippingInfo?.phone1}}</td>
            <td>Phone2:</td>
            <td>{{this.shippingInfo?.phone2}}</td>
            <td>Email:</td>
            <td>{{this.shippingInfo?.email}}</td>
        </tr>
        </table>
        <button (click)="onEditShipping()" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'">edit shipping</button>
    }
    @if (fintechService.editMode=="shipping") {
        <form [formGroup]="shipForm" novalidate>
            <div class="d-flex inline-flex">
                <mat-form-field>
                    <mat-label>company</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipCompany" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>first name</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipFirstName" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>last name</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipLastName" type="text" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="d-flex inline-flex">
                <mat-form-field>
                    <mat-label>address1</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipAddress1" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>address2</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipAddress2" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>city</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipCity" type="text" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="d-flex inline-flex">
                <mat-form-field>
                    <mat-label>state</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipState" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>country</mat-label>
                    <mat-select placeholder="" formControlName="shipCountry" (selectionChange)="onShipCountry()">
                        @for (country of m_countries; track country) {
                            <mat-option [value]="country.value">
                                {{ country.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>zip code</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipZipCode" type="text" autocomplete="off">
                </mat-form-field>
                </div>
                <div class="d-flex inline-flex">
                <mat-form-field>
                    <mat-label>phone1</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipPhone1" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>phone2</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipPhone2" type="text" autocomplete="off">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>email</mat-label>
                    <input inputrestriction="basic0" matInput placeholder="" formControlName="shipEmail" type="text" autocomplete="off">
                </mat-form-field>
                </div>
        </form>
        <div>
        <button (click)="onUpdateShipping()" class="subButton" mat-raised-button [disabled]="fintechService.busy">Update</button>
        <!--<button (click)="onCopyFromBilling()" class="subButton" mat-raised-button [disabled]="fintechService.busy">Copy from billing</button>-->
        <button (click)="onCancelShip()" class="subButton" mat-raised-button [disabled]="fintechService.busy">Cancel</button>
    </div>
    }
</div>
}
